import PropTypes from 'prop-types'
import UseDevicePixelRatio from '../hooks/useDevicePixelRatio'
import { AddNewPanel } from './addNewPanel'
import { GROUP_CLASS_NAME } from './constants'
import { conditionTargetInElement, getLayoutData } from './helper'
import './lang/i18n'

export const PanelContainer = ({
  children,
  changeLayout,
  isAllowDragDrop,
  handleAddNewPanel,
}) => {
  const devicePixelRatio = UseDevicePixelRatio()

  const onDrop = (e) => {
    e.preventDefault()
    const dragId = e.dataTransfer.getData('childId')
    const dragEl = document.getElementById(dragId)
    const parentEl = e.target.closest('#parentId')
    const children = parentEl.children

    for (let index = 0; index < children.length; index++) {
      const child = children[index]
      if (conditionTargetInElement(e, child, devicePixelRatio)) {
        if (
          dragEl.getBoundingClientRect().top <
            child.getBoundingClientRect().top ||
          (dragEl.getBoundingClientRect().top ===
            child.getBoundingClientRect().top &&
            dragEl.getBoundingClientRect().left <
              child.getBoundingClientRect().left)
        ) {
          parentEl.insertBefore(dragEl, children[index + 1])
        } else {
          parentEl.insertBefore(dragEl, child)
        }
      }
    }

    changeLayout(getLayoutData(parentEl))
  }

  const onDragOver = (e) => {
    e.preventDefault()
    e.stopPropagation()
  }

  return isAllowDragDrop ? (
    <>
      <div
        id="parentId"
        onDrop={onDrop}
        onDragOver={onDragOver}
        className={[GROUP_CLASS_NAME, 'dFlex flexWrap'].join(' ')}
      >
        {children}
      </div>
      <AddNewPanel handleAddNewPanel={handleAddNewPanel} />
    </>
  ) : (
    <div className={[GROUP_CLASS_NAME, 'dFlex flexWrap'].join(' ')}>
      {children}
    </div>
  )
}

PanelContainer.propTypes = {
  children: PropTypes.node.isRequired,
  changeLayout: PropTypes.func,
  isAllowDragDrop: PropTypes.bool,
  handleAddNewPanel: PropTypes.func,
}

PanelContainer.defaultProps = {
  changeLayout: () => {},
  isAllowDragDrop: false,
  handleAddNewPanel: () => {},
}
